export default "__VITE_ASSET__DVcwltbI__"